<template>
    <div :class="customClass">{{formatValue}}</div>
</template>
<script>
    import _ from "lodash";
    import moment from 'moment'

    /**
     * COMPONENTE DE CELDA DE TABLA PARA MOSTRAR LAS FECHAS
     * SE PUEDE USAR EN LAS TABLAS O EN OTRO SITIO.
     * */
    export default {
        name: "cell-date-type-component",
        data() {
            return {
                classValue: '',
                defaultFormat: 'DD/MM/YYYY'
            }
        },
        props: ['value', 'classToApply', 'format'],
        computed: {

            /**
             * Función formatear la fecha.
             * */
            formatValue: function () {
                if (_.isString(this.value)) {
                    try {
                        if (this.format) {
                            return moment(this.value).format(this.format);
                        } else {
                            return moment(this.value).format(this.defaultFormat);
                        }
                        //var dtValue = this.$moment(this.value);
                        //return this.$d(dtValue);
                    } catch (e) {
                        console.log("Err date - " + e.message);
                        return this.value;
                    }
                }
                else if (_.isDate(this.value)) {
                    if (this.format) {
                        return moment(this.value).format(this.format);
                    } else {
                        return moment(this.value).format(this.defaultFormat);
                    }
                }
                    //return this.$d(this.value);
            },
            cleanConditions(){
                return  this.conditionsDict.filter(x => x.Value != '')
            },
            customClass() {
                let cellClass = 'cellDateType';
                if (this.classToApply)
                    cellClass += ' ' + this.classToApply;
                return cellClass;
            }
        },
        methods: {
        }
    }

</script>
<style scoped>
    .cellDateType{
        text-align:center;
    }
</style>